import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import RolesListLayer from "../components/RolesListLayer";

const RolesPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Roles">
        <RolesListLayer />
      </MasterLayout>
    </>
  );
};

export default RolesPage;
